import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import {Scrollbar, A11y, EffectFade, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
function RoadmapOne() {
    return (
        <>
            {/* Roadmap area Start */}
            <section id="roadmap" className="rts-roadmap-area rts-section-gap bg-two">
                <div className="container">
                    <div className="section-top">
                        <div className="section-title-area">
                            <p
                                className="sub-title wow fadeInUp"
                                data-wow-delay=".2s"
                                data-wow-duration="2s"
                            >
                                Roadmap
                            </p>
                            <h2
                                className="section-title wow fadeInUp"
                                data-wow-delay=".5s"
                                data-wow-duration="2s"
                            >
                                Our Journey to Meme Greatness
                            </h2>
                        </div>
                        <p
                            className="desc wow fadeInUp"
                            data-wow-delay=".8s"
                            data-wow-duration="2s"
                        >
                            Our roadmap is a step-by-step guide to how we’re building a
                            revolutionary ecosystem for meme enthusiasts and crypto lovers alike.
                        </p>
                    </div>
                    <div
                        className="slider-inner mt--60 wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                    >
                        <div className="float-right">
                            <Swiper
                                // install Swiper modules
                                modules={[Pagination, EffectFade, Scrollbar, A11y, Autoplay]}
                                className="roadmap-slider"
                                speed={1000}
                                slidesPerView={3.5}
                                spaceBetween={30}
                                loop={true}
                                autoplay={true}
                                pagination={{
                                    el: '.swiper-pagination',
                                    clickable: true,
                                  }}
                                breakpoints={{
                                    1500: { slidesPerView: 3.5 },
                                    1199: { slidesPerView: 2 },
                                    991: { slidesPerView: 2 },
                                    767: { slidesPerView: 1 },
                                    450: { slidesPerView: 1 },
                                    0: { slidesPerView: 1 },
                                }}
                                >
                                    <SwiperSlide>
                                        <div className="roadmap-top with-after2">
                                            <div className="tag">
                                                Phase 1
                                                <img src="assets/images/roadmap/phase.svg" alt="" />
                                            </div>
                                        </div>
                                        <div className="roadmap-wrapper">
                                            <div className="inner">
                                                <h3 className="title">Token Launch, Community Building</h3>
                                                <ul>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Token Launch
                                                    </li>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Community Building
                                                    </li>
                                                </ul>
                                                <img
                                                    className="float-img"
                                                    src="assets/images/roadmap/coin.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="roadmap-top with-after2">
                                            <div className="tag">
                                                Phase 2
                                                <img src="assets/images/roadmap/phase.svg" alt="" />
                                            </div>
                                        </div>
                                        <div className="roadmap-wrapper">
                                            <div className="inner">
                                                <h3 className="title">Checkout or Wallet Integration</h3>
                                                <ul>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Access the Purchase Page
                                                    </li>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Apply the Code
                                                    </li>
                                                </ul>
                                                <img
                                                    className="float-img"
                                                    src="assets/images/roadmap/coin.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="roadmap-top with-after2">
                                            <div className="tag">
                                                Phase 3
                                                <img src="assets/images/roadmap/phase.svg" alt="" />
                                            </div>
                                        </div>
                                        <div className="roadmap-wrapper">
                                            <div className="inner">
                                                <h3 className="title">Enjoy Your Rewards Instantly!</h3>
                                                <ul>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Immediate Notification
                                                    </li>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Real-Time Updates
                                                    </li>
                                                </ul>
                                                <img
                                                    className="float-img"
                                                    src="assets/images/roadmap/coin.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="roadmap-top with-after2">
                                            <div className="tag">
                                                Phase 4
                                                <img src="assets/images/roadmap/phase.svg" alt="" />
                                            </div>
                                        </div>
                                        <div className="roadmap-wrapper">
                                            <div className="inner">
                                                <h3 className="title">Enjoy Your Rewards Instantly!</h3>
                                                <ul>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Immediate Notification
                                                    </li>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Real-Time Updates
                                                    </li>
                                                </ul>
                                                <img
                                                    className="float-img"
                                                    src="assets/images/roadmap/coin.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="roadmap-top with-after2">
                                            <div className="tag">
                                                Phase 1
                                                <img src="assets/images/roadmap/phase.svg" alt="" />
                                            </div>
                                        </div>
                                        <div className="roadmap-wrapper">
                                            <div className="inner">
                                                <h3 className="title">Token Launch, Community Building</h3>
                                                <ul>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Token Launch
                                                    </li>
                                                    <li>
                                                        <img src="assets/images/token/tik.svg" alt="" />
                                                        Community Building
                                                    </li>
                                                </ul>
                                                <img
                                                    className="float-img"
                                                    src="assets/images/roadmap/coin.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                        </div>
                        <div className="swiper-pagination" />
                    </div>
                </div>
                <div className="shape-area">
                    <img src="assets/images/roadmap/shape-01.svg" alt="" />
                    <img src="assets/images/roadmap/shape-02.svg" alt="" />
                    <img src="assets/images/roadmap/shape-03.svg" alt="" />
                    <img src="assets/images/roadmap/coin-2.svg" alt="" />
                    <img src="assets/images/roadmap/coin-2.svg" alt="" />
                    <img src="assets/images/roadmap/coin-3.svg" alt="" />
                    <img src="assets/images/roadmap/leaf-01.svg" alt="" />
                    <img src="assets/images/roadmap/leaf-01.svg" width={10} alt="" />
                </div>
            </section>
            {/* Roadmap area End */}
        </>

    )
}

export default RoadmapOne